<script>
  import { availableSorts, currentSorts } from "./stores/sort-order-store.js";
  export let collection;

  let isSearchResults = window.location.href.includes('search');
  let sessionSearchSortIndex = +sessionStorage.getItem('searchSortIndex');
  let sessionCollectionSortIndex = +sessionStorage.getItem('collectionSortIndex');

  let selectedSortIndex = isSearchResults ? sessionSearchSortIndex : sessionCollectionSortIndex;

  function changeSort() { 
    currentSorts.set(
      $availableSorts.find(sort => sort.label === selectedSortLabel)
    );

    let chosenSortIndex = sortOptions.findIndex(sort => sort.label === selectedSortLabel);

    if (isSearchResults) {
      sessionStorage.setItem("searchSortIndex", chosenSortIndex);
    } else {
      sessionStorage.setItem("collectionSortIndex", chosenSortIndex);
    }
  }

  const sortOptions = $availableSorts
    .filter(sort => {
      // Don't show Relevance on collections, but do show it on search
      if (sort.label === "Relevance" && collection !== null) {
        return false;
      }

      // Don't show Recommended on search
      if (sort.label === "Recommended" && collection === null) {
        return false;
      }

      // Don't show Recommended on collections without manual sort order turned on
      if (sort.label === "Recommended" && typeof collection === "object" && collection !== null && collection.sort_order !== "manual") {
        return false;
      }

      return true;
    })
    .map(sort => {
      if (sort.label === "Recommended" && collection !== null) {
        sort.sortBy = sort.sortBy.replace("XXX", collection.id);
      }

      return sort;
    });
  
  currentSorts.set(sortOptions[selectedSortIndex]);
  let selectedSortLabel = $currentSorts.label;

</script>

{#if currentSorts}
  <div class="flex b5 items-center">
    <label for="sort-select" id="sort-label" class="font-medium mr-1 mt-[1px]">SORT:</label>
    <select id="sort-select" aria-labelledby="sort-label" name="sort" bind:value={selectedSortLabel} on:change={changeSort} class="bg-white appearance-none">
      {#each sortOptions as sort}
        <option value="{sort.label}">{sort.label}</option>
      {/each}
    </select>
  </div>
{/if}

